// REACT
import React, { useEffect, useState } from "react";

// REACT BOOTSTRAP
import { Col, Row } from "react-bootstrap";

// REDUX
import { useDispatch, useSelector } from "react-redux";

// REACT ROUTER
import { useParams } from "react-router-dom";

// INTERNATIONALIZATION
import { FormattedMessage } from "react-intl";

// STORE ACTIONS
import { editApplication } from "store/actions";

// DATA
import { permissions } from "data";

// COMPONENTS
import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import Input from "components/Form/input";
import SaveChangesButton from "components/Form/save-changes-button";

const ApplicationPrivileges = () => {
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    const { singleApplication } = useSelector((state) => state.applications);
    const [defaultValues, setDefaultValues] = useState(null);

    useEffect(() => {
        if (singleApplication) {
            setDefaultValues({
                permissions: singleApplication?.permissions || {},
            });
        }
    }, [singleApplication]);

    const onSubmitPermissions = (data) => {
        dispatch(
            editApplication({
                endpointName: "permissions",
                id: applicationId,
                data,
            })
        );
    };
    return (
        <FormWrapper>
            <Form onSubmit={onSubmitPermissions} defaultValues={defaultValues}>
                <Row className="mb-3">
                    <Col xs={12} md={3}>
                        <h5 className="side-title">
                            <FormattedMessage id="appPermissions" />
                        </h5>
                    </Col>
                    <Col xs={12} md={9}>
                        <Row className="gy-4">
                            {permissions?.map((permission, index) => (
                                <Col
                                    xxl={3}
                                    xl={4}
                                    md={6}
                                    sm={6}
                                    xs={12}
                                    key={index}
                                >
                                    <div className="privilege-item">
                                        <h5 className="title">
                                            <FormattedMessage id={permission} />
                                        </h5>
                                        <Row as="label">
                                            <input
                                                type="hidden"
                                                name={`permissions.${index}.id`}
                                                value={permission}
                                            />
                                            <Input
                                                type="checkbox"
                                                name={`permissions.${index}.canRead`}
                                                langId={false}
                                                rules={{
                                                    required: false,
                                                }}
                                                value={true}
                                                xs={4}
                                            />
                                            <Col as="small">
                                                <FormattedMessage id="canRead" />
                                            </Col>
                                        </Row>
                                        <Row as="label">
                                            <Input
                                                type="checkbox"
                                                name={`permissions.${index}.canWrite`}
                                                langId={false}
                                                rules={{
                                                    required: false,
                                                }}
                                                value={true}
                                                xs={4}
                                            />
                                            <Col as="small">
                                                <FormattedMessage id="canWrite" />
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>
                <SaveChangesButton />
            </Form>
        </FormWrapper>
    );
};

export default ApplicationPrivileges;
